import script from "./NextPrevButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./NextPrevButtons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__